import _ from 'lodash';

import {
  MACHINE_LIST, MACHINE_CREATE, MACHINE_DELETE, MACHINE_READ, MACHINE_UPDATE
} from '@/store/actions/machine';
import { CLIENT_LIST, CLIENT_READ, CLIENT_RESET } from '@/store/actions/client';

import machineApi from '@/api/machine';

/* eslint-disable camelcase */


const state = {
  machines: [],

  machine: {
    machine_id: null,
    client_id: null,
    serial_number: null,
    model_name: null,
    manufacturing_date: null,
    installation_date: null,
    operator_phone_number: null,
    revision_date: null,
    repair_date: null,
    repair_comment: null,
    taking_back_date: null,
    exchange_date: null,

    // API Computed data
    revenue: 0
  },
  defaultItem: {
    machine_id: null,
    client_id: null,
    serial_number: null,
    model_name: null,
    manufacturing_date: null,
    installation_date: null,
    operator_phone_number: null,
    revision_date: null,
    repair_date: null,
    repair_comment: null,
    taking_back_date: null,
    exchange_date: null,

    // Computed data
    revenue: 0
  }
};

const getters = {
};

const actions = {
  async [MACHINE_LIST] ({ commit, dispatch }, { client_id }) {
    await dispatch(CLIENT_LIST);
    commit(MACHINE_LIST, await machineApi.getMachines({ client_id }));
  },

  async [MACHINE_CREATE] ({ commit }, data) {
    commit(MACHINE_CREATE, await machineApi.createMachine(data));
  },

  async [MACHINE_READ] ({ commit, dispatch, rootGetters, state }, id) {
    commit(MACHINE_READ, { machine_id: id });

    commit(MACHINE_READ, await machineApi.getMachine(id));
    if (state.machine.client_id && rootGetters.hasPermission('client', state.machine.client_id)) {
      await dispatch(CLIENT_READ, state.machine.client_id);
    } else {
      await dispatch(CLIENT_RESET);
    }
  },

  async [MACHINE_UPDATE] ({ commit }, data) {
    commit(MACHINE_UPDATE, Object.assign({}, data, await machineApi.updateMachine(data)));
  },

  async [MACHINE_DELETE] ({ commit }, id) {
    await machineApi.deleteMachine(id);
    commit(MACHINE_DELETE, id);
  }
};

const mutations = {
  [MACHINE_LIST] (state, machines) {
    state.machines = machines;
  },

  [MACHINE_CREATE] (state, machine) {
    state.machines.push(machine);
  },

  [MACHINE_READ] (state, machine) {
    state.machine = _.merge({}, state.defaultItem, machine);
  },

  [MACHINE_UPDATE] (state, machine) {
    const idx = state.machines.findIndex(elt => elt.machine_id === machine.machine_id);
    state.machines.splice(idx, 1, machine);
  },

  [MACHINE_DELETE] (state, id) {
    const idx = state.machines.findIndex(elt => elt.machine_id === id);
    if (idx !== -1) {
      state.machines.splice(idx, 1);
    }
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
